<script setup lang="ts">
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { isValidKennitala } from '@/assets/Utils/kennitala'

const props = defineProps<{
  modelValue: string
  label?: string
  disabled?: boolean
  error?: boolean
  errorMessages?: string[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

// Format display (######-####) and emit clean digits
const formatted = computed({
  get: () => {
    if (!props.modelValue) return ''
    const digits = props.modelValue.replace(/\D/g, '')
    if (digits.length <= 6) return digits
    return digits.slice(0, 6) + '-' + digits.slice(6, 10)
  },
  set: (val: string) => {
    const digits = val.replace(/\D/g, '').slice(0, 10)
    emit('update:modelValue', digits)
  }
})

// Only validate kennitala if not empty
const rules = {
  formatted: {
    isValid: (v: string) => !v || isValidKennitala(v)
  }
}

const v$ = useVuelidate(rules, { formatted })
</script>

<template>
  <v-text-field
    v-model="formatted"
    :label="label"
    :disabled="disabled"
    placeholder="######-####"
    variant="outlined"
    density="comfortable"
    :error="error || v$.formatted.$error"
    :error-messages="[
      ...(errorMessages || []),
      v$.formatted.$dirty && v$.formatted.isValid?.$invalid
        ? $t('lan_umsokn_step2_kennitala_invalid')
        : ''
    ].filter(Boolean)"
  />
</template>
